import { styled } from '@/style';

import { variants } from './variants';

export const Hr = styled.hrBox<{
  variant?: keyof typeof variants;
}>`
  ${({ variant }) => variants[variant || 'simple']}
`;
